/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { makeStyles } from '@mui/styles';
import { List, ListItem, Typography, Divider, ListItemText } from '@mui/material';
import { projectsDataAtom, openProjectNameAtom } from '../Atoms';
import MoreInfoDialog from './MoreInfoDialog';

const useStyles = makeStyles({
  projectsList: {
    backgroundColor: '#ffffff',
  },
  dot: {
    width: '16px',
    height: '16px',
    minWidth: '16px',
    borderRadius: '50px',
    margin: '16px',
  },
});

const InternalList = function InternalList() {
  const classes = useStyles();
  const intl = useIntl();
  const projectsData = useRecoilValue(projectsDataAtom);
  const openProjectName = useRecoilValue(openProjectNameAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const [valueName, setValueName] = useState(null);
  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === openProjectName && x.isCurrent === 1));
  }, [openProjectName, projectsData]);

  const internal = [
    {
      id: 'iFINECO',
      title: 'FIN-ECO',
      note: 'iFINECOnote',
      area: 'INT',
    },
    {
      id: 'iPRDLOG',
      title: 'PRD-LOG',
      note: 'iPRDLOGnote',
      area: 'INT',
    },
    {
      id: 'iTECIND',
      title: 'TEC-IND',
      note: 'iTECINDnote',
      area: 'INT',
    },
    {
      id: 'iDOCQUA',
      title: 'DOC-QUA',
      note: 'iDOCQUAnote',
      area: 'INT',
    },
    {
      id: 'iHRCOMM',
      title: 'HR-COMM',
      note: 'iHRCOMMnote',
      area: 'INT',
    },
  ];
  const getComplexityColor = (complexity) => {
    if (complexity > 6) return '#D0021B';
    if (complexity < 4) return '#8BDB2D';
    return '#F5A623';
  };

  return (
    <List className={classes.projectsList}>
      {currentProjectData &&
        internal.map((val) => (
          <div key={val.id} className={classes.valueEntry} onClick={() => setValueName(val.id)}>
            <ListItem
              alignItems="center"
              sx={{ paddingLeft: 0 }}
              secondaryAction={
                <div className={classes.valueCol}>
                  <Typography variant="caption" color="blackgrey">
                    {intl.messages.VALUE}
                  </Typography>
                  <Typography variant="h6" sx={{ textAlign: 'center', fontSize: '30px' }}>
                    {currentProjectData[val.id]}
                  </Typography>
                </div>
              }
            >
              <div
                className={classes.dot}
                style={{ backgroundColor: getComplexityColor(currentProjectData[val.id]) }}
              />
              <ListItemText
                primary={val.title}
                secondary={
                  <Typography noWrap sx={{ textOverflow: 'ellipsis', width: '90%' }}>
                    {currentProjectData[val.note] || intl.messages.NONOTES}
                  </Typography>
                }
              />
            </ListItem>
            <Divider variant="inset" />
          </div>
        ))}
      <MoreInfoDialog
        valueName={valueName}
        open={valueName}
        close={() => setValueName(null)}
        currentProjectData={currentProjectData}
      />
    </List>
  );
};

export default InternalList;
